import React from 'react';
import Lottie from 'react-lottie';

import { useTranslation } from 'react-i18next';
import novaLoadingAnimation from './nova-loading-animation.json';
import { LoadingContainer, LoadingIconContainer } from './styles';

function Loading() {
  const { t: translate } = useTranslation('chatbot');

  return (
    <LoadingContainer>
      <LoadingIconContainer
        aria-label={translate('conversation.loading.a11y_label')}
      >
        <Lottie
          style={{ width: '100%', height: '100%' }}
          options={{
            loop: true,
            autoplay: true,
            animationData: novaLoadingAnimation,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          isClickToPauseDisabled={true}
        />
      </LoadingIconContainer>
    </LoadingContainer>
  );
}

export { Loading };
